// @ts-nocheck
import {
  FETCH_ORDER_FULFILLED,
  FETCH_ORDER_REJECTED,
  FETCH_ORDERS_FULFILLED,
  FETCH_ORDERS_REJECTED,
  DESELECT_ORDER,
  REFUND_ORDER_FULFILLED,
  CANCEL_ORDER_FULFILLED,
} from './orderActionTypes';

const initialState = {
  orders: null,
  orderDetails: null,
};

export default function orderReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ORDERS_FULFILLED:
      return {
        ...state,
        orders: action.payload,
      };
    case FETCH_ORDERS_REJECTED:
      return {
        ...state,
        orders: null,
      };
    case FETCH_ORDER_FULFILLED:
      return {
        ...state,
        orderDetails: action.payload,
      };
    case FETCH_ORDER_REJECTED:
      return {
        ...state,
        orderDetails: null,
      };
    case REFUND_ORDER_FULFILLED:
      return {
        ...state,
        orderDetails: action.payload,
      };
    case CANCEL_ORDER_FULFILLED:
      return {
        ...state,
        orderDetails: action.payload,
      };
    case DESELECT_ORDER:
      return {
        ...state,
        orderDetails: null,
      };
    default:
      return state;
  }
}
